import { render, staticRenderFns } from "./DecommissionedAssets.vue?vue&type=template&id=d38f8a72&"
import script from "./DecommissionedAssets.vue?vue&type=script&lang=js&"
export * from "./DecommissionedAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports